<template>
  <ViewWrapper>
    <h1>
      CashFlo App
    </h1>

    <p>
      Page not found.
    </p>

    <ButtonLink
      url="cashflo://email_verified"
    >
      Open Cashflo
    </ButtonLink>
  </ViewWrapper>
</template>

<script>
  import ButtonLink from '@/components/ButtonLink'
  import ViewWrapper from '@/components/ViewWrapper'

  export default {
    components: {
      ButtonLink,
      ViewWrapper,
    },
  }
</script>

<style scoped lang="scss">
  p {
    margin-bottom: 40px;
  }
</style>
